// extracted by mini-css-extract-plugin
export default {"consent":"VerifyPhoneNumber_consent__lKQVN","skeletonLoadingAnimation":"VerifyPhoneNumber_skeletonLoadingAnimation__pMbKt"};